import { Component, Input, OnDestroy } from '@angular/core';
import { WorkflowStep4 } from 'src/app/models/workflow';
import { RequestBuilderService } from '../request-builder.service';
import { EditorActor } from 'src/app/models/requestEditor';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { SendGroupModel } from 'src/app/models/sendgroup.model';
import { Subscription } from 'rxjs';
import { DocumentActor } from 'src/app/models/actors';

@Component({
    selector: 'app-step-4',
    templateUrl: './step-4.component.html'
})
export class Step4Component implements OnDestroy {

    @Input() workflowData?: WorkflowStep4;
    sendGroups: SendGroupModel[] = [];
    isLoading: boolean = false;
    groups: SendGroupModel[] = [];
    actors: DocumentActor[] = [];
    combinedActionList: EditorActor[] = [];
    private workflowSubscription: Subscription | null = null;
    private sendgroupsSubscription: Subscription | null = null;
    private actorSubscription: Subscription | null = null;


    constructor(private requestBuilderService: RequestBuilderService) {
        this.workflowSubscription= this.requestBuilderService.workflowData$.subscribe(workflowData => {
            this.workflowData = workflowData.step4;
        });
        this.sendgroupsSubscription = this.requestBuilderService.sendgroups$.subscribe(sendgroups => {
            this.sendGroups = sendgroups;
            this.showActorsPerSendGroup();
        });
        this.actorSubscription = this.requestBuilderService.actors$.subscribe(actors => {
            this.actors = actors;
        });
    }


    ngOnDestroy(): void {
        if(this.workflowSubscription){
            this.workflowSubscription.unsubscribe();
        }
        if(this.sendgroupsSubscription){
            this.sendgroupsSubscription.unsubscribe();
        }
        if(this.actorSubscription){
            this.actorSubscription.unsubscribe();
        }
    }

    showActorsPerSendGroup() {
        let sendGroupsForDragging: SendGroupModel[] = [];
        this.sendGroups = this.sendGroups.sort((a:SendGroupModel, b:SendGroupModel) => {
            if (a.order > b.order) {
                return 1;
            }
        
            if (a.order < b.order) {
                return -1;
            }
        
            return 0;
        });
        this.sendGroups?.forEach((x,index) => {
            if(index === 0 && !x.deadline) {
                x.deadline = new Date(new Date().setDate(new Date().getDate() + x.deadlineDays));
            }
            if(index-1 > -1){
                let deadelineDays = 0;
                for(let i = 1; i < index; i++){
                    deadelineDays += this.sendGroups[i].deadlineDays;
                }

                x.sendDate = new Date(new Date(this.sendGroups[0].deadline).setDate(new Date(this.sendGroups[0].deadline).getDate() + deadelineDays));
            }

            //SendgroupTemp for all real sendgroups
            if(this.sendGroups[index-1 > -1 ? index-1 : 0].actions.length > 0){
                let sendGroupTemp = new SendGroupModel();
                sendGroupTemp.sendGroupGuid = index + '.5-PLACEHOLDER';
                sendGroupTemp.name = "_SendGroup";
                sendGroupTemp.order = x.order-1;
                sendGroupTemp.deadlineDays = x.deadlineDays;
                sendGroupTemp.actions = [];
                sendGroupsForDragging.push(sendGroupTemp);
            }

            //sendgroup
            sendGroupsForDragging.push(x);

            //always the last template sendgroup for dragging.
            if((this.sendGroups.length-1) === index) {
                let finalSendGroupTemp = new SendGroupModel();
                finalSendGroupTemp.sendGroupGuid = index+1 + '.5-PLACEHOLDER';
                finalSendGroupTemp.name = "_SendGroup";
                finalSendGroupTemp.order = x.order+1;
                finalSendGroupTemp.deadline = x.deadline;
                finalSendGroupTemp.deadlineDays = x.deadlineDays;
                finalSendGroupTemp.actions = [];
                sendGroupsForDragging.push(finalSendGroupTemp);
            }

        });
        this.groups = sendGroupsForDragging.sort((a:SendGroupModel, b:SendGroupModel) => {
            if (a.order > b.order) {
                return 1;
            } else if (a.order < b.order) {
                return -1;
            } else {
                return 0;
            }
        });
        return this.groups;
    }

    dropItem(event: CdkDragDrop<any[]>) {
        var newPositionAction = this.combinedActionList[event.currentIndex];
        var oldositionAction = this.combinedActionList[event.previousIndex];

        if (newPositionAction.sendGroupId) {
            oldositionAction.sendGroupId = newPositionAction.sendGroupId;
        }

        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }
    }
}
